import Vue from 'vue'
import Vuex from 'vuex'
const fb = require('./firebaseConfig.js')
const { isBefore } = require('date-fns')

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: null,
    userWaivers: [],
    userSurveys: [],
    fetchingProfile: false,
    fetchingWaivers: false,
    fetchingSurveys: false,
    fetching: true
  },
  getters: {
    fetchingData: state => {
      return state.fetching
    },
    hasProfile: state => {
      return state.userProfile !== null
    },
    displayName: state => {
      if (state.userProfile) {
        return state.userProfile.name
      }
      return ''
    },
    email: state => {
      if (state.userProfile) {
        return state.userProfile.email
      }
      return ''
    },
    traits: state => {
      if (state.userProfile) {
        return state.userProfile.traits
      }
      return []
    },
    lastWaiver: state => {
      if (state.userWaivers.length === 0) {
        return null
      }

      var waivers = []
      state.userWaivers.forEach(x => {
        waivers.push({
          completed: x.completed.toDate(),
          email: x.email
        })
      })

      const w = waivers.sort((a, b) => {
        return isBefore(a.completed, b.completed) ? 1 : -1
      })[0]

      return w
    },
    lastSurvey: state => {
      if (state.userSurveys.length === 0) {
        return null
      }

      var surveys = []
      state.userSurveys.forEach(x => {
        surveys.push({
          completed: x.completed.toDate(),
          email: x.email,
          answers: x.answers,
          id: x.id,
          override: 'override' in x ? x.override : false,
          comments: 'comments' in x ? x.comments : ''
        })
      })

      const s = surveys.sort((a, b) => {
        return isBefore(a.completed, b.completed)  ? 1 : -1
      })[0]

      return s
    }
  },
  mutations: {
    setCurrentUser(state, val) {
        state.currentUser = {
          email: val.email,
          displayName: val.displayName
        }
    },
    setUserProfile(state, val) {
        state.userProfile = val
    },
    setUserWaivers(state, val) {
      state.userWaivers = val
    },
    setUserSurveys(state, val) {
      state.userSurveys = val
    },
    setFetching(state, val) {
      console.log("FETCHING", val)
      state.fetching = val
    },
    setFetchingProfile(state, val) {
      console.log("FETCHING PROFILE", val)
      state.fetchUserProfile = val
    },
    setFetchingWaivers(state, val) {
      console.log("FETCHING WAIVERS", val)
      state.fetchUserWaivers = val
    },
    setFetchingSurveys(state, val) {
      console.log("FETCHING SURVEYS", val)
      state.fetchUserSurveys = val
    }
  },
  actions: {
    fetchUserWaivers ({ commit, state }) {
      commit('setFetchingWaivers', true)
      fb.waiverCollection
      .where("email", "==", state.currentUser.email)
      .orderBy("completed", "desc")
      .limit(1)
      .get()
      .then(res => {
        if (res.docs.length > 0) {
          commit('setUserWaivers', res.docs.map(d => d.data()))
        }
      })
      commit('setFetchingWaivers', false)
    },
    fetchUserSurveys({ commit, state }) {
      commit('setFetchingSurveys', true)
      fb.surveyCollection
      .where("email", "==", state.currentUser.email)
      .orderBy("completed", "desc")
      .limit(1)
      .get()
      .then(res => {
        if (res.docs.length > 0) {
          commit('setUserSurveys', res.docs.map(d => {return {id: d.id, ...d.data()}}))
        }
      })
      commit('setFetchingSurveys', false)
    },
    fetchUserProfile({ commit, state }) {
        const admins = ['dbuckalew@suscc.edu', 'lnorth@suscc.edu', 'tlaye@suscc.edu', 'rdavis@suscc.edu']
        commit('setUserProfile', null)
        commit('setFetchingProfile', true)
        fb.profileCollection.where("email", "==", state.currentUser.email)
        .get()
        .then(res => {
          if (res.docs.length > 0) {
            commit('setUserProfile', res.docs[0].data())
          } else {
            var traits = []
            if (state.currentUser.email.split('@')[1] === 'suscc.edu') {
              traits.push('staff')
              if (admins.indexOf(state.currentUser.email) !== -1) {
                traits.push('admin')
              }
              if (state.currentUser.email === 'rdavis@suscc.edi') {
                traits.push('health')
              }
              const profile = {
                name: state.currentUser.displayName,
                email: state.currentUser.email,
                traits: traits
              }
              commit('setUserProfile', profile)
              fb.profileCollection.add(profile)
            }
          }
        }).catch(err => {
            console.log(err)
        })
        commit('setFetchingProfile', false)
    },
    saveWaiver({ state }) {
      var result = {
        email: state.userProfile.email,
        completed: new Date()
      }
      return new Promise((resolve, reject) => {
        fb.waiverCollection.add(result)
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    saveProfile({ state }, data) {
      var traits = data.splice()
      if (state.currentUser.email.split('@')[1] === 'mail.suscc.edu') {
        traits.push('student')
      }
      if (state.currentUser.email.split('@')[1] === 'suscc.edu') {
        traits.push('faculty')
      }
      var result = {
        traits: traits,
        email: state.currentUser.email,
        name: state.currentUser.displayName
      }
      console.log("NEW PROFILE", result)
      return new Promise((resolve, reject) => {
        fb.profileCollection.add(result)
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    saveSurvey({ state }, survey) {
      var result = {
        answers: survey,
        email: state.userProfile.email,
        completed: new Date()
      }
      return new Promise((resolve, reject) => {
        fb.surveyCollection.add(result)
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
      })
    }
  },
  modules: {
  }
})